<template>
<div class="fc-page ca-page ca-page-cash_journal_list"><header class="fc-child-heading"><h2>金额流水查询</h2><p>查看学员金额账户的收支与余额变动</p></header><section class="fc-filters" aria-label="金额流水查询筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>查看学员金额账户的收支与余额变动</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="学号" outlined v-model="query.studentNo" color="#d9363e" hide-details>
								</v-text-field></div><div class="fc-filter-cell"><v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName" color="#d9363e" hide-details>
								</v-text-field></div><div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined color="#d9363e" hide-details></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
									</v-date-picker>
								</v-menu></div><div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined color="#d9363e" hide-details></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
									</v-date-picker>
								</v-menu></div></div><div class="fc-filter-bottom"><span>查询当前校区的记录</span><div class="fc-filter-actions"><v-btn type="submit" depressed dark color="#d9363e" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section><section class="fc-records"><div class="fc-list-heading"><h3>账户流水明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ca-table ca-cash_journal_list" :mobile-breakpoint="0"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">




				<template v-slot:item.inOut="{item}">
					<span v-if="item.inOut=='1'" class="ca-flow-in">增加</span>
					<span v-if="item.inOut=='2'" class="ca-flow-out">减少</span>
				</template>
				<template v-slot:item.amount="{item}">
					<span v-if="item.inOut=='1'" class="ca-flow-in">+{{item.amount}}</span>
					<span v-if="item.inOut=='2'" class="ca-flow-out">-{{item.amount}}</span>
				</template>

			<template v-slot:item.studentName="{item}"><strong class="fc-student-name">{{item.studentName}}</strong></template><template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template><template v-slot:item.lastAmount="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.lastAmount)<0}">{{item.lastAmount}}</span></template><template v-slot:item.balanceAmount="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.balanceAmount)<0}">{{item.balanceAmount}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条</span><span class="fc-total">共 {{data.total}} 条记录</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section></div>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "cash-journal-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
	
				data: {
					total: 0,
					headers: [
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '进/出',
							value: 'inOut',
							sortable: false
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false
						},
						{
							text: '业务前学费',
							value: 'lastAmount',
							sortable: false
						},
						{
							text: '本次学费',
							value: 'amount',
							sortable: false
						},
						{
							text: '业务后学费',
							value: 'balanceAmount',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '备注',
							align: 'left',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					studentNo:"",
					studentName:""
				},
			}
		},
		created() {
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();
				let url = `/financial/student/cash/journal/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.studentNo) {
					url += "&studentNo=" + this.query.studentNo;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			inOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "增加";
				} else if (state === "2") {
					stName = "减少";
				}
				return stName;
			},
			inOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/cash-account.scss"></style>
